const Banner = {
  "--AICartoon-banner-title-color": "#FFFFFF",
  "--AICartoon-banner-subtitle-color": "#fff",

  "--AICartoon-banner-upload-bg": "rgba(255,255,255,0.06)",
  "--AICartoon-banner-upload-shadow": "",

  "--AICartoon-banner-upload-btn-color": "#FFFFFF",
  "--AICartoon-banner-upload-btn-shadow": "",
  "--AICartoon-banner-upload-btn-bg": "#034EF3",

  "--AICartoon-banner-upload-max-color": "#808080",

  "--AICartoon-banner-upload-tips-color": "#CCCCCC",
}

const Price = {
  "--AICartoon-price-title-color": "#252325",

  "--AICartoon-price-item-shadow": "none",
  "--AICartoon-price-item-shadow-hover": "none",
  "--AICartoon-price-item-border": "",
  "--AICartoon-price-item-border-hover": "",

  // 价格顶部
  "--AICartoon-price-tag-bg": "#F2F4F7",
  "--AICartoon-price-tag-bg-hover": "#2D2E33",
  "--AICartoon-price-tag-suffix": "#252325",
  "--AICartoon-price-tag-suffix-hover": "#fff",
  // 详情模块颜色
  "--AICartoon-price-main-bg": "#F2F4F7",
  "--AICartoon-price-main-bg-hover": "#2D2E33",
  // 价格颜色
  "--AICartoon-price-money-suffix": "#101012",
  "--AICartoon-price-money-suffix-hover": "#fff",
  // 套餐详情颜色
  "--AICartoon-price-desc-suffix": "#101012",
  "--AICartoon-price-desc-suffix-hover": "#fff",
  // 购买按钮
  "--AICartoon-price-pay-button-suffix": "#FFF",
  "--AICartoon-price-pay-button-suffix-hover": "#FFF",
  "--AICartoon-price-pay-button-bg": "#034EF3",
  "--AICartoon-price-pay-button-shadow": "none",
  "--AICartoon-price-pay-button-bg-hover": "#034EF3",
  // 套餐 tips
  "--AICartoon-price-tip-suffix": "#252325",
  "--AICartoon-price-tip-suffix-hover": "#fff",
  "--AICartoon-price-tip-bg": "#F2F4F7",
  "--AICartoon-price-tip-bg-hover": "#2D2E33",
}

const Questions = {
  "--AICartoon-questions-title-color": "#252325",
  "--AICartoon-questions-item-bg": "#F2F4F3",
  "--AICartoon-questions-item-bg-open": "#fff",
  "--AICartoon-questions-item-boxshadow": "none",
  "--AICartoon-questions-item-boxshadow-open": "0px 20px 50px 0px rgba(0,0,0,0.15)",

  "--AICartoon-questions-item-border": "none",
  "--AICartoon-questions-item-border-open": "none",

  "--AICartoon-questions-item-number-suffix": "#0270F9",
  "--AICartoon-questions-item-number-suffix-open": "#0270F9",

  "--AICartoon-questions-item-suffix": "#101012",
  "--AICartoon-questions-item-suffix-open": "#101012",
  "--AICartoon-questions-item-des-suffix": '#101012',
}

const Comment = {
  "--AICartoon-comment-title-color": "#252325",

  "--AICartoon-comment-bg": "#fff",

  "--AICartoon-comment-item-bg": "#F2F4F3",
  "--AICartoon-comment-item-bg-hover": "#034EF3",

  "--AICartoon-comment-item-border": "none",
  "--AICartoon-comment-item-border-hover": "none",

  "--AICartoon-comment-item-boxshadow": "none",
  "--AICartoon-comment-item-boxshadow-hover": "none",

  "--AICartoon-comment-item-subtitle-suffix": "#252325",
  "--AICartoon-comment-item-subtitle-suffix-hover": "#fff",

  "--AICartoon-comment-item-name-suffix": "#4C484C",
  "--AICartoon-comment-item-name-suffix-hover": "#fff",

  "--AICartoon-comment-item-city-suffix": "#999199",
  "--AICartoon-comment-item-city-suffix-hover": "#fff",
}

const Case = {
  "--AICartoon-case-title-color": "#252325",

  "--AICartoon-case-bg": "#fff",
  "--AICartoon-case-item-bg": "#fff",
  "--AICartoon-case-item-bg-hover": "#fff",

  "--AICartoon-case-item-title-color": "#252525",
  "--AICartoon-case-item-title-color-hover": "#252525",
  "--AICartoon-case-item-desc-color": "#4C484C",
  "--AICartoon-case-item-desc-color-hover": "#4C484C",

  "--AICartoon-case-item-shadow": "",
  "--AICartoon-case-item-shadow-hover": "0px 20px 50px 0px rgba(0,0,0,0.15)",
  "--AICartoon-case-item-border": "none",
  "--AICartoon-case-item-border-hover": "none",
}

const Step = {
  "--AICartoon-step-title-color": "#252325",

  "--AICartoon-step-item-title-color": "#252325",
  "--AICartoon-step-item-title-color-hover": "#252325",

  "--AICartoon-step-bg": '#F2F4F7',
  "--AICartoon-step-item-bg": "#fff",
  "--AICartoon-step-item-bg-hover": "#fff",
  "--AICartoon-step-item-shadow": "",
  "--AICartoon-step-item-shadow-hover": "0px 20px 50px 0px rgba(0,0,0,0.15)",
  "--AICartoon-step-item-border": "none",
  "--AICartoon-step-item-border-hover": "none",
}


export const coustomAICartoonBlackBlueTheme = {
  //主题背景颜色
  "--theme-primary": "#0270F9",
  //默认黑
  "--theme-primary-black": "#252325",
  //默认白
  "--theme-primary-white": "#ffffff",
  // 页脚 logo 字体颜色
  "--theme-primary-footer-logo-suffix": "#0270F9",
  // 页头 登录 字体颜色
  "--theme-primary-login-btn-suffix": "#fff",
  // 不透明度70%
  "--theme-primary-white-70": "#b2b2b2",
  //主题亮色
  "--theme-primary-suffix": "#212121",
  //主题深副色
  "--theme-primary-dark-sub": "#E4430F",
  //主题浅副色
  "--theme-primary-light-sub": "#FF8761",
  //价格 tag
  "--theme-primary-price-tag": "#4C3626",
  "--theme-primary-price-tag-bg": "#FFCF52",
  //tiny 类
  "--theme-primary-tiny": "#666166",
  //footer 背景色
  "--theme-primary-footer-bg": "#000000",
  //输入框聚焦
  "--theme-focus": "#3377ff",
  //输入框错误
  "--theme-focus-err": "#ea3042",

  ...Banner,
  ...Price,
  ...Questions,
  ...Comment,
  ...Case,
  ...Step
}